import styled from 'styled-components';
import { HeadingExtraBoldL, BodyRegularS, BodyBoldS } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';
import BuildingIcon from '@/assets/icons/companyIcon.svg?react';
import EyeIconComponent from '@/assets/icons/eyeIcon.svg?react';

interface IScrollElements {
  theme: ITheme;
  scroll?: boolean;
}

export const SurveyName = styled(HeadingExtraBoldL)<IScrollElements>`
  width: 734px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ theme, scroll }: IScrollElements) => `
    margin-top: ${theme.layout.spacing.mikro};
    transition: all 0.5s;
    ${
  scroll
    ? `
      font-size: 20px;
      line-height: 23px;
    `
    : ''
}
  `}
`;

export const SurveyOrganizationCont = styled(BodyRegularS)<IScrollElements>`
  display: flex;
  ${({ theme, scroll }: IScrollElements) => `
    margin-top: ${theme.layout.spacing.mikro};
    transition: all 0.5s;
    ${scroll ? 'opacity: 0' : 'opacity: 1'};
    ${scroll ? 'height: 0' : ''};
  `}
`;

export const OrganizationName = styled(BodyBoldS)``;

export const CompanyIcon = styled(BuildingIcon)`
  margin-right: 7px;
`;

export const SurveyNameCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ButtonsCont = styled.div`
  display: flex;
  margin-left: 51px;
`;

export const EyeIcon = styled(EyeIconComponent)`
  margin-right: 8px;
`;

export const IconImg = styled.img`
  ${({ theme }: IThemeProvider) => `
      margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const DarkButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  > button {
    min-width: 160px;
  }

  .ant-spin-spinning {
    padding-bottom: 4px;

    ${() => `
    .ant-spin-dot-item {
      background: white;
    }
  `}
  }
`;
